/* @flow */
import { Request } from "shared/src/services/Requests";
const RequestBuilder = new Request.Builder("depotmanagement", "depotsettings", true);

const client = {
    getStoreInformation(storeId: string, country: string) {
        const template = "/public/store/{country}/{storeId}/info";
        const pathParams = { storeId, country };
        return RequestBuilder.path(template, pathParams).get();
    },

    getStoresForCountry(country: string) {
        const template = "/public/store/{country}/info";
        const pathParams = { country };
        return RequestBuilder.path(template, pathParams).get();
    }
};

export default client;

export const { getStoreInformation, getStoresForCountry } = client;
